
// ShoppingCart
import Currency from '../Currency';

const Listings53025 = [
  {
    productId: 245689674110,
    productRef: 256201110,
    type: 'Buy',
    title: "5 Bedroom Luxury Duplex",
    productName: "5 Bedroom Luxury Duplex",
    imageURL: '../../RealEstate/KingsStridesApartment/6BedroomLuxuryDuplex-ShelterAfriqueEstate/img1.jpg',
    imgUrl1: '../../RealEstate/KingsStridesApartment/6BedroomLuxuryDuplex-ShelterAfriqueEstate/img1.jpg',
    imgUrl2: '../../RealEstate/KingsStridesApartment/6BedroomLuxuryDuplex-ShelterAfriqueEstate/img2.jpg',
    imgUrl3: '../../RealEstate/KingsStridesApartment/6BedroomLuxuryDuplex-ShelterAfriqueEstate/img3.jpg',
    imgUrl4:  '../../RealEstate/KingsStridesApartment/6BedroomLuxuryDuplex-ShelterAfriqueEstate/img4.jpg',
    imgUrl5: '../../RealEstate/KingsStridesApartment/6BedroomLuxuryDuplex-ShelterAfriqueEstate/img5.jpg',
    imgUrl6: '../../RealEstate/KingsStridesApartment/6BedroomLuxuryDuplex-ShelterAfriqueEstate/img5.jpg',
    imgUrl7: '../../RealEstate/KingsStridesApartment/6BedroomLuxuryDuplex-ShelterAfriqueEstate/img5.jpg',
    imgUrl8: '../../RealEstate/KingsStridesApartment/6BedroomLuxuryDuplex-ShelterAfriqueEstate/img5.jpg',
    imgUrl9: '../../RealEstate/KingsStridesApartment/6BedroomLuxuryDuplex-ShelterAfriqueEstate/img5.jpg',
    imgUrl10: '../../RealEstate/KingsStridesApartment/6BedroomLuxuryDuplex-ShelterAfriqueEstate/img5.jpg',
    videourl: '../../RealEstate/KingsStridesApartment/6BedroomLuxuryDuplex-ShelterAfriqueEstate/5BedroomApartmentShelterAfrique.mp4',
    dummyUrl: '../../RealEstate/KingsStridesApartment/6BedroomLuxuryDuplex-ShelterAfriqueEstate/img5.jpg',
    displayPrice: "500M Slightly Negotiable",
    price: 500000000,
    currency: '₦',
    availableUnits: 1,
    negotiable: false,
    contactNo: '08036096802',
    date_posted: '30-05-2025',
    city: 'Uyo',
    state: 'Akwa-Ibom',
    areaName: 'Shelter Afrique Estate',
    postedBy: 278935,
    category: 'Residential',
    group: 'RealEstate',
    availability: true,
    bedroom: 5,
    bathroom: 4,
    kitchen: 2,
    sittingArea: 2,
    studyRoom: 0,
    swimmingPool: true,
    gym: true,
    locationImg: `${`📍`}`,
    priceImg: `${`💵`}`,
    description: `
    Features:\n
    Land Size: 1,434SQMs\n 
    -Spacious 5-Bedroom layout
    -Family-size swimming pool, gazebo & private garden
    -Fully equipped gym
    -Ample compound with security post
    -Modern kitchen with inverter fridge, cooler, microwave, and oven
    
    ---
    
    ✨ Key Features  
    Documents:
    -Deed of Assignment
    -Purchase Receipt
    -C of O
    -Governor's consent
    -survey plan
    -Power of Attorney
    `,
  },

  {
    productId: 24568967513,
    productRef: 25620113,
    type: 'Lease',
    title: "3 Bedroom Serviced Apartment",
    productName: "3 Bedroom Serviced Apartment",
    imageURL: '../../RealEstate/KingsStridesApartment/Luxury3BedroomServiceApartment-ShelterAfriqueExt/img1.jpg',
    imgUrl1: '../../RealEstate/KingsStridesApartment/Luxury3BedroomServiceApartment-ShelterAfriqueExt/img1.jpg',
    imgUrl2: '../../RealEstate/KingsStridesApartment/Luxury3BedroomServiceApartment-ShelterAfriqueExt/img2.jpg',
    imgUrl3: '../../RealEstate/KingsStridesApartment/Luxury3BedroomServiceApartment-ShelterAfriqueExt/img3.jpg',
    imgUrl4:  '../../RealEstate/KingsStridesApartment/Luxury3BedroomServiceApartment-ShelterAfriqueExt/img4.jpg',
    imgUrl5: '../../RealEstate/KingsStridesApartment/Luxury3BedroomServiceApartment-ShelterAfriqueExt/img5.jpg',
    imgUrl6: '../../RealEstate/KingsStridesApartment/Luxury3BedroomServiceApartment-ShelterAfriqueExt/img6.jpg',
    imgUrl7: '../../RealEstate/KingsStridesApartment/Luxury3BedroomServiceApartment-ShelterAfriqueExt/img7.jpg',
    imgUrl8: '../../RealEstate/KingsStridesApartment/Luxury3BedroomServiceApartment-ShelterAfriqueExt/img8.jpg',
    imgUrl9: '../../RealEstate/KingsStridesApartment/Luxury3BedroomServiceApartment-ShelterAfriqueExt/img9.jpg',
    imgUrl10: '../../RealEstate/KingsStridesApartment/Luxury3BedroomServiceApartment-ShelterAfriqueExt/img10.jpg',
    videourl: '../../RealEstate/KingsStridesApartment/Luxury3BedroomServiceApartment-ShelterAfriqueExt/Luxury3BedroomApartmentShelteAfriqueExt.mp4',
    dummyUrl: '../../images/product1/emeraldStone.jpg',
    availability: true,
    bedroom: 3,
    bathroom: 2,
    kitchen: 2,
    sittingArea: 2,
    studyRoom: 0,
    swimmingPool: true,
    gym: true,
    area: '2345',
    locationImg: `${`📍`}`,
    priceImg: `${`💵`}`,
    description: `
    Features:\n
    📍 Shelter Afrique Estate Extension.  
    💵 Full Booking (11am–11am): ₦250K  
    🌞 Day Booking (7am–6pm): ₦150K  
    🌙 Night Booking (7pm–6am): ₦150K  
    🍽️ Includes one complimentary meal
    
    ---
    
    ✨ Key Features  
    - Fully detached bungalow with privacy  
    - Large green outdoor space + sit-out bar  
    - Superfast internet (Starlink & CSS Fiber)  
    - 24/7 power (inverter + soundproof gen)  
    - Smart TVs, ACs, Netflix, Prime  
    - PS5 & Oculus (on request)  
    - Daily cleaning + complimentary breakfast  
    - Secure estate with ample parking
    `,
    shortDescription: `This tastefully built 5 bedroom duplex i`,
    displayPrice: "250k - Full Booking",
    price: 150000,
    currency: '₦',
    availableUnits: 1,
    negotiable: false,
    contactNo: '08036096802',
    date_posted: '30-05-2025',
    city: 'Uyo',
    state: 'Akwa-Ibom',
    areaName: 'Shelter Afrique',
    category: 'Residential',
    group: 'RealEstate',
  },

  {
    productId: 24568967616,
    productRef: 25620116,
    type: 'Buy',
    title: "Cute tongue Chihuahua Puppie dog",
    productName: "Cute tongue Chihuahua Puppie dog",
    imageURL: '../../images/dogs/chihuahua.jpg',
    imgUrl1: '../../images/dogs/chihuahua.jpg',
    imgUrl2: '../../images/dogs/chihuahua.jpg',
    imgUrl3: '../../images/dogs/chihuahua.jpg',
    imgUrl4:  '../../images/dogs/chihuahua.jpg',
    imgUrl5: '../../images/dogs/chihuahua.jpg',
    imgUrl6: '../../images/dogs/chihuahua.jpg',
    imgUrl7: '../../images/dogs/chihuahua.jpg',
    imgUrl8: '../../images/dogs/chihuahua.jpg',
    imgUrl9: '../../images/dogs/chihuahua.jpg',
    imgUrl10: '../../images/dogs/chihuahua.jpg',
    videourl: '../../images/VentolaHotels/dumvid.MP4',
    dummyUrl: '../../images/dogs/chihuahua.jpg',
    availability: true,
    locationImg: `${`📍`}`,
    priceImg: `${`💵`}`,
    description: `Lorem sum corem Loren sum corem Lorem sum corem Loren sum corem 
    Lorem sum corem Loren sum corem Lorem sum corem Loren sum corem Lorem sum corem Loren sum corem`,
    shortDescription: 'Lorem sum corem Loren sum corem Lorem sum corem Loren',
    displayPrice: "1300 on sale",
    price: 50000,
    currency: ' ₦',
    availableUnits: 1,
    negotiable: false,
    contactNo: '08036096802',
    date_posted: '30-05-2025',
    city: 'Port-Harcourt',
    state: 'Rivers',
    areaName: 'Woji',
    postedBy: 278935,
    category: 'Dog',
    group: 'Shop and Listings',
  }, 

  {
    productId: 24500067356017,
    productRef: 25634516017,
    type: 'Buy',
    title: "6 Bedroom Duplex",
    productName: "6 Bedroom Duplex",
    imageURL: '../../RealEstate/KingsStridesApartment/6BedroomDuplex-ShelterAfrique/img1.jpg',
    imgUrl1: '../../RealEstate/KingsStridesApartment/6BedroomDuplex-ShelterAfrique/img1.jpg',
    imgUrl2: '../../RealEstate/KingsStridesApartment/6BedroomDuplex-ShelterAfrique/img2.jpg',
    imgUrl3: '../../RealEstate/KingsStridesApartment/6BedroomDuplex-ShelterAfrique/img3.jpg',
    imgUrl4:  '../../RealEstate/KingsStridesApartment/6BedroomDuplex-ShelterAfrique/img4.jpg',
    imgUrl5: '../../RealEstate/KingsStridesApartment/6BedroomDuplex-ShelterAfrique/img5.jpg',
    imgUrl6: '../../RealEstate/KingsStridesApartment/6BedroomDuplex-ShelterAfrique/img6.jpg',
    imgUrl7: '../../RealEstate/KingsStridesApartment/6BedroomDuplex-ShelterAfrique/img7.jpg',
    imgUrl8: '../../RealEstate/KingsStridesApartment/6BedroomDuplex-ShelterAfrique/img8.jpg',
    imgUrl9: '../../RealEstate/KingsStridesApartment/6BedroomDuplex-ShelterAfrique/img9.jpg',
    imgUrl10: '../../RealEstate/KingsStridesApartment/6BedroomDuplex-ShelterAfrique/img10.jpg',
    videourl: '../../RealEstate/KingsStridesApartment/6BedroomDuplex-ShelterAfrique/Luxury-6-Bedroom-Duplex-ShelterAfrique.mp4',
    dummyUrl: '../../RealEstate/KingsStridesApartment/6BedroomDuplex-ShelterAfrique/img1.jpg',
    availability: true,
    shortDescription: `This tastefully built 6 bedroom duplex i`,
    displayPrice: "650M Outright",
    price: '₦650,000,000',
    currency: '₦',
    availableUnits: 1,
    negotiable: false,
    contactNo: '08036096802',
    date_posted: '03-09-2025',
    city: 'Uyo',
    state: 'Akwa-Ibom',
    areaName: 'Shelter Afrique',
    category: 'Residential',
    group: 'RealEstate',
    bedroom: 6,
    bathroom: 2,
    kitchen: 2,
    sittingArea: 2,
    studyRoom: 0,
    swimmingPool: true,
    gym: true,
    area: '2345',
    locationImg: `${`📍`}`,
    priceImg: `${`💵`}`,
    description: `
    Land Size: 
     1,434SQMs\n 
    Features:\n
     -Spacious 6-Bedroom layout \n
     -Family-size swimming pool, gazebo & private garden \n
     -Fully equipped gym \n
     -Ample compound with security post \n
     -Modern kitchen with inverter fridge, cooler, microwave, and oven \n
    
    Documents:
    -Deed of Assignment \n
    -Purchase Receipt \n
    -C of O \n
    -Governor's consent \n
    -survey plan \n
    -Power of Attorney
    
    `,
    
  },
  
  {
    productId: 245689674110,
    productRef: 256201110,
    type: 'Buy',
    title: "6 Bedroom Luxury Duplex",
    productName: "6 Bedroom Luxury Duplex",
    imageURL: '../../RealEstate/KingsStridesApartment/6BedroomLuxuryDuplex-ShelterAfriqueEstate/img1.jpg',
    imgUrl1: '../../RealEstate/KingsStridesApartment/6BedroomLuxuryDuplex-ShelterAfriqueEstate/img1.jpg',
    imgUrl2: '../../RealEstate/KingsStridesApartment/6BedroomLuxuryDuplex-ShelterAfriqueEstate/img2.jpg',
    imgUrl3: '../../RealEstate/KingsStridesApartment/6BedroomLuxuryDuplex-ShelterAfriqueEstate/img3.jpg',
    imgUrl4:  '../../RealEstate/KingsStridesApartment/6BedroomLuxuryDuplex-ShelterAfriqueEstate/img4.jpg',
    imgUrl5: '../../RealEstate/KingsStridesApartment/6BedroomLuxuryDuplex-ShelterAfriqueEstate/img5.jpg',
    imgUrl6: '../../RealEstate/KingsStridesApartment/6BedroomLuxuryDuplex-ShelterAfriqueEstate/img5.jpg',
    imgUrl7: '../../RealEstate/KingsStridesApartment/6BedroomLuxuryDuplex-ShelterAfriqueEstate/img5.jpg',
    imgUrl8: '../../RealEstate/KingsStridesApartment/6BedroomLuxuryDuplex-ShelterAfriqueEstate/img5.jpg',
    imgUrl9: '../../RealEstate/KingsStridesApartment/6BedroomLuxuryDuplex-ShelterAfriqueEstate/img5.jpg',
    imgUrl10: '../../RealEstate/KingsStridesApartment/6BedroomLuxuryDuplex-ShelterAfriqueEstate/img5.jpg',
    videourl: '../../RealEstate/KingsStridesApartment/6BedroomLuxuryDuplex-ShelterAfriqueEstate/6-Bedroom-Duplex-ShelterAfrique.mp4',
    dummyUrl: '../../RealEstate/KingsStridesApartment/6BedroomLuxuryDuplex-ShelterAfriqueEstate/img5.jpg',
    displayPrice: "150k per Night",
    price: 120000000,
    currency: '₦',
    availableUnits: 1,
    negotiable: false,
    contactNo: '08036096802',
    date_posted: '30-05-2025',
    city: 'Port-Harcourt',
    state: 'Rivers',
    areaName: 'GRA',
    postedBy: 278935,
    category: 'Apartments',
    group: 'Reservation and Bookings',
    availability: true,
    bedroom: 2,
    bathroom: 2,
    kitchen: 1,
    sittingArea: 2,
    studyRoom: 0,
    swimmingPool: true,
    gym: false,
    locationImg: `${`📍`}`,
    priceImg: `${`💵`}`,
    description: `
    Land Size: 
     1,434SQMs\n 
    Features:\n
     -Spacious 6-Bedroom layout \n
     -Family-size swimming pool, gazebo & private garden \n
     -Fully equipped gym \n
     -Ample compound with security post \n
     -Modern kitchen with inverter fridge, cooler, microwave, and oven \n
    
    Documents:
    -Deed of Assignment \n
    -Purchase Receipt \n
    -C of O \n
    -Governor's consent \n
    -survey plan \n
    -Power of Attorney
    
    `,

  },

  {
    productId: 24500067356320,
    productRef: 25634516320,
    type: 'Buy',
    title: "Affordable Service Apartment",
    productName: "Affordable Service Apartment",
    imageURL: '../../images/VentolaHotels/hotel3.jpg',
    imgUrl1: '../../images/VentolaHotels/hotel3.jpg',
    imgUrl2: '../../images/apartment/photo17.jpg',
    imgUrl3: '../../images/apartment/photo18.jpg',
    imgUrl4:  '../../images/apartment/photo19.jpg',
    imgUrl5: '../../images/apartment/photo20.jpg',
    imgUrl6: '../../images/apartment/photo21.jpg',
    imgUrl7: '../../images/apartment/photo22.jpg',
    imgUrl8: '../../images/apartment/photo23.jpg',
    imgUrl9: '../../images/apartment/photo24.jpg',
    imgUrl10: '../../images/apartment/photo25.jpg',
    videourl: '../../images/VentolaHotels/dumvid.MP4',
    dummyUrl: '../../images/product1/emeraldStone.jpg',
    availability: true,
    shortDescription: `This tastefully built 5 bedroom duplex i`,
    displayPrice: "2500 per month",
    price: 1500,
    currency: '$',
    availableUnits: 1,
    negotiable: false,
    contactNo: '08036096802',
    date_posted: '03-09-2025',
    city: 'Uyo',
    state: 'Akwa-Ibom',
    areaName: 'Shelter Afrique',
    category: 'Residential',
    group: 'RealEstate',
    bedroom: 1,
    bathroom: 2,
    kitchen: 2,
    sittingArea: 2,
    studyRoom: 0,
    swimmingPool: true,
    gym: true,
    area: '2345',
    locationImg: `${`📍`}`,
    priceImg: `${`💵`}`,
    description: `
    Land Size: 
     1,434SQMs\n 
    Features:\n
     -Spacious 6-Bedroom layout \n
     -Family-size swimming pool, gazebo & private garden \n
     -Fully equipped gym \n
     -Ample compound with security post \n
     -Modern kitchen with inverter fridge, cooler, microwave, and oven \n
    
    Documents:
    -Deed of Assignment \n
    -Purchase Receipt \n
    -C of O \n
    -Governor's consent \n
    -survey plan \n
    -Power of Attorney
    
    `,
  },

  {
    productId: 24568967616864,
    productRef: 2562011630040,
    type: 'Buy',
    title: "Touch Classic Centre Table",
    productName: "Touch Classic Centre Table",
    imageURL: '../../Households/CentreTable/PeterFrankUyo/pics1.jpg',
    imgUrl1: '../../Households/CentreTable/PeterFrankUyo/pics1.jpg',
    imgUrl2: '../../Households/CentreTable/PeterFrankUyo/pics2.jpg',
    imgUrl3: '../../Households/CentreTable/PeterFrankUyo/pics3.jpg',
    imgUrl4:  '../../Households/CentreTable/PeterFrankUyo/pics4.jpg',
    imgUrl5: '../../Households/CentreTable/PeterFrankUyo/pics5.jpg',
    imgUrl6: '../../Households/CentreTable/PeterFrankUyo/pics6.jpg',
    imgUrl7: '../../Households/CentreTable/PeterFrankUyo/pics7.jpg',
    imgUrl8: '../../Households/CentreTable/PeterFrankUyo/pics8.jpg',
    imgUrl9: '../../Households/CentreTable/PeterFrankUyo/pics8.jpg',
    imgUrl10: '../../Households/CentreTable/PeterFrankUyo/pics8.jpg',
    videourl: '../../Households/CentreTable/PeterFrankUyo/CentreTablePeteFrankUyo.MP4',
    dummyUrl: '../../Households/CentreTable/PeterFrankUyo/pics3.jpg',
    availability: true,
    locationImg: `${`📍`}`,
    priceImg: `${`💵`}`,
    shortDescription: 'Simple in style, smooth to feel, classic in every detail.',
    displayPrice: "45k Only - Now selling ",
    price: 45000,
    currency: '₦',
    availableUnits: 1,
    negotiable: false,
    contactNo: '08036096802',
    date_posted: '30-05-2025',
    city: 'Uyo',
    state: 'Akwa-Ibom',
    areaName: 'Nwaniba Road',
    postedBy: 2785436,
    category: 'Center-Table',
    group: 'Shop and Listings',
    description: `
    Features:\n
     Simple in style, smooth to feel, classic in every detail. 
     This artistic piece brings warmth in every room. 
     It evokes the elements of comfy textures that agrees with beauty, finesse
     and that natural confident outlook.
    
    `,
  }, 

  {
    productId: 24500067356495,
    productRef: 256345164950,
    type: 'Lease',
    title: "Serviced Apartment",
    productName: "Affordable Serviced Apartment",
    imageURL: '../../RealEstate/Apartments/BlueRockApartments/August132026/pics1.png',
    imgUrl1: '../../RealEstate/Apartments/BlueRockApartments/August132026/pics2.png',
    imgUrl2: '../../RealEstate/Apartments/BlueRockApartments/August132026/pics3.png',
    imgUrl3: '../../RealEstate/Apartments/BlueRockApartments/August132026/pics3.png',
    imgUrl4:  '../../RealEstate/Apartments/BlueRockApartments/August132026/pics3.png',
    imgUrl5: '../../RealEstate/Apartments/BlueRockApartments/August132026/pics3.png',
    imgUrl6: '../../RealEstate/Apartments/BlueRockApartments/August132026/pics3.png',
    imgUrl7: '../../RealEstate/Apartments/BlueRockApartments/August132026/pics3.png',
    imgUrl8: '../../RealEstate/Apartments/BlueRockApartments/August132026/pics3.png',
    imgUrl9: '../../RealEstate/Apartments/BlueRockApartments/August132026/pics3.png',
    imgUrl10: '../../RealEstate/Apartments/BlueRockApartments/August132026/pics3.png',
    videourl: '../../RealEstate/Apartments/BlueRockApartments/August132026/vid1.MP4',
    dummyUrl: '../../RealEstate/Apartments/BlueRockApartments/August132026/pics1.png',
    availability: true,
    shortDescription: `Check into comfort, designed and serviced for your comfort. `,
    displayPrice: "900,000 per night",
    price: 900000,
    currency: `${Currency().Naira}`,
    availableUnits: 1,
    negotiable: false,
    contactNo: '08036096802',
    date_posted: '03-09-2025',
    city: 'Lagos-Island',
    state: 'Lagos',
    areaName: 'Lekki',
    category: 'Residential',
    group: 'RealEstate',
    bedroom: 2,
    bathroom: 2,
    kitchen: 1,
    sittingArea: 1,
    studyRoom: 0,
    swimmingPool: true,
    gym: true,
    area: '2345',
    locationImg: `${`📍`}`,
    priceImg: `${`💵`}`,
    description: `
    Features:\n
     Check into comfort, designed and serviced for your comfort. 
     Cozy ambience. 
     Indulge and try out our delicious yet nourishing cussines.
     Equipped for your warmth and relaxation, keeping you refreshed and revitalized.
    
    `,
  },

]


export default Listings53025;